import { render, staticRenderFns } from "./SharesUnits.vue?vue&type=template&id=33f5214a&scoped=true&"
import script from "./SharesUnits.vue?vue&type=script&lang=js&"
export * from "./SharesUnits.vue?vue&type=script&lang=js&"
import style0 from "./SharesUnits.vue?vue&type=style&index=0&id=33f5214a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5214a",
  null
  
)

export default component.exports